import React, { PureComponent } from 'react';
import PropTypes from "prop-types";
import InvoiceTile from './components/InvoiceTile.js';
import MessageCard from '../../../components/Cards/MessageCard.js';
import MonthTile from '../../../components/MonthTile.js';
import i18n from '../../../localization/i18n.js';
import tokens from '../../../localization/tokens.js';
class Index extends PureComponent {
  render() {
    const {
      history,
      hideBalance
    } = this.props;
    const styles = {
      invoiceHistoryContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row'
      }
    };
    return /*#__PURE__*/React.createElement("div", {
      style: styles.invoiceHistoryContainer
    }, !history || history.length === 0 ? /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.labels.invoices.noBillingHistory),
      subtitle: i18n.t(tokens.labels.invoices.nextChargePhrase)
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InvoiceTile, {
      isCurrentAllocation: true,
      status: "Pending",
      isFirstInvoice: false,
      onClick: () => this.props.getCurrentInvoice()
    }), this.props.history.map((invoice, i) => !hideBalance ? /*#__PURE__*/React.createElement(InvoiceTile, {
      testid: i === 0 ? 'invoice-history-tile' : undefined,
      key: invoice.dateAdded,
      date: invoice.dateAdded,
      total: invoice.grandTotal,
      status: invoice.status,
      isFirstInvoice: i === history.length - 1,
      onClick: () => this.props.selectInvoice(invoice)
    }) : /*#__PURE__*/React.createElement(MonthTile, {
      testid: i === 0 ? 'invoice-history-tile' : undefined,
      key: invoice.dateAdded,
      date: invoice.dateAdded,
      isFirstInvoice: i === history.length - 1,
      onClick: () => this.props.selectInvoice(invoice),
      status: invoice.status
    }))), /*#__PURE__*/React.createElement("span", {
      id: this.props.testid
    }));
  }
}
Index.propTypes = {
  history: PropTypes.array,
  hideBalance: PropTypes.bool
};
export default Index;